<template>
  <div>
    <data-list :payload="invoiceObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination" :key="reInit" :loading="invoiceObj.loading">
      <v-container fluid grid-list-xl slot="filterForm">
        <v-layout row class="pt-0">
          <v-flex xs12 sm6 md4 lg3 class="pt-2 pb-2">
            <v-select item-text="text" class="pa-1" outlined dense v-model="statusFilter" hide-details item-value="value" clearable :items="invoiceStatus" :label="$t('message.common.status')"></v-select>
          </v-flex>
          <v-flex lg6 class="pt-2 pb-2" v-if="$vuetify.breakpoint.lgAndUp"></v-flex>
          <v-flex xs12 sm6 md4 lg3 class="pt-2 pb-2">
            <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="getListHandler" @click:append="getListHandler" class="pa-1 search-hint-padding" v-model="search" outlined dense :label="$t('message.common.search')"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </data-list>
  </div>
</template>
<script>
/* eslint-disable */
import DataList from '@/components/DataList.vue'
import { mapState } from 'vuex'
import Nordea from '@/mixins/InvoiceNordea/index'
import xLedger from '@/mixins/InvoicexLedger/index'
export default {
  data () {
    return {
      MODULE_URL: 'invoices',
      customerId: this.$route.query.customerid,
      orderId: this.$route.params.order_id,
      invoiceFormDialog: false,
      invoiceObj: {
        isHeader: true,
        isHideAdd: true,
        isOffer: true,
        isInvoice: true,
        showExport: true,
        export: this.exportHandler,
        xledger: this.exportToXledger,
        nordea: this.exportToNordea,
        sync: this.syncHandler,
        orderInvoice: true,
        fromSBInvoice: false,
        isStock: true,
        selection: [],
        showSelect: true,
        addNewRoute: () => null,
        headers: [],
        list: [],
        loading: true,
        editProp: 'number',
        editURL: (item) => item.type.value === 1 ? `/orders/edit/${this.$route.params.order_id}/invoice/actions/${item.id}` : `/orders/edit/${this.$route.params.order_id}/invoice/creditnote/${item.id}`,
        hasFilters: true,
        sync24seven: true,
        actionsList: [{
          click: (item) => item,
          icon: () => 'mdi-checkbox-marked-circle-outline',
          color: (item) => '',
          is_show: (item) => item.syncedto24seven
        }]
      },
      total: 0,
      search: '',
      reInit: 0,
      statusFilter: null,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.INVOICE_INDEX) ? this.$store.state.INVOICE_INDEX : { sortBy: ['number'], itemsPerPage: 25, sortDesc: [true], search: '' }
    }
  },
  components: {
    DataList
  },
  mixins: [Nordea, xLedger],
  computed: {
    ...mapState(['INVOICE_INDEX']),
    invoiceTypes () {
      return [
        { text: this.$t('message.common.draft'), id: 1 },
        { text: this.$t('message.order.download'), id: 2 },
        { text: 'EHF', id: 3 },
        { text: this.$t('message.customer.email'), id: 4 }
      ]
    },
    headers () {
      let heads = [{
        text: this.$t('message.tickets.number'),
        value: 'number',
        width: '8%'
      },
      {
        text: this.$t('message.order.customer'),
        value: 'customer_name',
        width: '15%'
      }, {
        text: this.$t('message.tickets.type'),
        sortable: false,
        value: 'type.text',
        width: '10%'
      }, {
        text: this.$t('message.invoice.invoicedDate'),
        value: 'invoice_date',
        width: '8%'
      }, {
        text: this.$t('message.invoice.duedate'),
        value: 'due_date',
        width: '8%'
      }, {
        text: this.$t('message.orders.totalExVat'),
        value: 'total_sum',
        align: 'end',
        width: '10%'
      }, {
        text: this.$t('message.invoice.totalSum'),
        value: 'grand_total',
        align: 'end',
        width: '10%'
      }, {
        text: 'DG',
        value: 'dg_percentage',
        align: 'end',
        width: '10%'
      }, {
        text: this.$t('message.common.status'),
        value: 'completion_type',
        sortable: false,
        width: '10%'
      }, {
        text: this.$t('message.product.currency'),
        value: 'currencylist_name',
        width: '10%'
      }, {
        text: '24seven',
        value: 'syncedto24seven',
        isBoolean: true,
        sortable: false,
        width: '8%'
      }]
      return heads
    }
  },
  watch: {
    pagination (val) {
      let model = { type: 'INVOICE_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    search (val) {
      if (!val) this.getListHandler()
    },
    statusFilter (val) {
      this.getListHandler()
    }
  },
  mounted () {
    if (!this.$formatter.isEmptyObject(this.$store.state.F_ORDER_INVOICE)) {
      let invoiceFilters = this.$formatter.cloneVariable(this.$store.state.F_ORDER_INVOICE)
      let { status, search } = invoiceFilters.filter
      this.statusFilter = status || null
      this.search = search || ''
    }
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        let payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.invoiceObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.invoiceObj.loading = true
      this.invoiceObj.module = this.MODULE_URL
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let sortByValue = ''
      if (sortBy && sortBy[0]) sortByValue = sortBy[0]
      let model = {
        descending: sortDesc && sortDesc[0],
        page,
        sortby: sortByValue,
        search: this.search,
        rowsperpage: itemsPerPage,
        status: this.statusFilter || '',
        orderid: this.orderId
      }
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, model)
        .then((response) => {
          let { items, total } = response.data
          const list = []
          items.forEach(element => {
              element.invoice_date = this.$formatter.formatDate(element.invoice_date, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
              element.due_date = this.$formatter.formatDate(element.due_date, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
              element.grand_total = this.$formatter.replaceDotWithComma(element.grand_total)
              element.total_sum = this.$formatter.replaceDotWithComma(element.total_sum)
              element.dg_percentage = this.$formatter.replaceDotWithComma(element.dg_percentage)
              element.completion_type = this.getInvoiceCreatedType(element.completion_type)
              if (!element.number) element.number = '(Utkast)'
              if (element.type) {
                this.invoiceType.forEach(item => {
                  if (item.value === element.type) {
                    element.type = item
                  }
                })
                this.invoiceStatus.forEach(item => {
                  if (item.value === element.status) {
                    element.status = item
                  }
                })
              }
              list.push(element)
          })
          this.invoiceObj.list = list
          this.total = total
          /* remember filter and search text */
          let data = { type: 'F_ORDER_INVOICE', data: { filter: { status: this.statusFilter || 0, search: this.search } } }
          this.$store.commit('rememberFilter', data)
          /*  */
        }).finally (() => {
          this.invoiceObj.loading = false
        })
    },
    getInvoiceCreatedType (type) {
      const getType = this.invoiceTypes.find(x => x.id === type)
      if (getType) return getType.text
      else return ''
    },
    exportHandler (ids) {
      let model = { 'ids': this.$formatter.cloneVariable(ids) }
      this.$_executeApi('post', `invoices/export_for_uni`, model).then(response => {
        if (response) {
          window.open(`${process.env.VUE_APP_URL}file/download/?fileName=${response.data}`, '_blank')
          this.invoiceObj.selection = []
          this.getListHandler()
        }
      })
    },
    createInvoice () {
      this.loading = true
      this.$_executeApi('post', `/invoices/create_invoice_from_order/${this.orderId}`).then(response => {
        this.$router.push(`/orders/edit/${this.$route.params.order_id}/invoice/actions/${response.data.id}`)
      }).finally(() => {
        this.loading = false
      })
    },
    syncHandler (ids) {
      let model = { 'ids': this.$formatter.cloneVariable(ids) }
      this.$_executeApi('post', `invoices/sync_to_24seven`, model).then(response => {
        if (response) {
          if (response.data) {
            this.invoiceObj.selection = []
            this.getListHandler()
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.syncedSuccess') })
          }
        }
      })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
    this.$root.$off('deleteItems')
    this.$root.$off('deleteSuccess')
  }
}
</script>
